import { render, staticRenderFns } from "./program.vue?vue&type=template&id=875d3b78&"
import script from "./program.vue?vue&type=script&lang=js&"
export * from "./program.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports